import {combineReducers} from 'redux';

import currentEstimatedGrades from './currentEstimatedGradesReducer';
import studentList from './studentListReducer';

const binderStudentsReducer = combineReducers({
  currentEstimatedGrades,
  studentList,
});

export default binderStudentsReducer;
